/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 18:47:49
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import InputNumber from 'src/types/iview/InputNumber';
import DeclareMaintenanceApi, { DeclareMaintenanceDOI } from './api/declareMaintenanceApi';
import { createNamespace } from 'src/util/bem';
import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import  DatePicker from 'src/types/iview/DatePicker';

export namespace OperateMaintenanceVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        declare_type: Integer;
        operational_time: Integer;
        cause: string;
        operationalSite: { deviceId: Integer; components: string[]; key: number }[];
        status: number;
        refuse_cause: string;
        audit_time: string;
        auditor: string;
        timestamp: Integer;
    }
}
let uid = 1;

@Component
class OperateMaintenanceModal extends Vue.Component<OperateMaintenanceVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: OperateMaintenanceVOI.FormDataI = {
        declare_type: null,
        operational_time: null,
        cause: '',
        operationalSite: [{ deviceId: null, components: [], key: 0 }],
        status: 1,
        refuse_cause: '',
        audit_time: '',
        auditor: '',
        timestamp: null,
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        this.formData.timestamp = DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
        let params: DeclareMaintenanceDOI.OperateParamsI = {
            ...this.formData,
            operational_info: {
                data: this.formData.operationalSite.map(i => ({
                    operational_equipment: i.components,
                    operational_site: i.deviceId,
                })),
            },
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await DeclareMaintenanceApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id;
                res = await DeclareMaintenanceApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    genKey() {
        return uid++;
    }
    add(index: number) {
        this.formData.operationalSite.splice(index + 1, 0, { deviceId: null, components: [], key: this.genKey() });
    }
    sub(index: number) {
        this.formData.operationalSite.splice(index, 1);
    }
    async mounted() {
        if (this.operate !== EnumOperates.Add.getName()) {
            let { code, data } = await DeclareMaintenanceApi.searchDetail({ id: this.id });
            if (code === 0) {
                this.formData = {
                    declare_type: data.declare_type_id,
                    operational_time: +data.operational_time,
                    cause: data.cause,
                    operationalSite: data.operational_site.data.map(i => ({
                        deviceId: i.operational_id,
                        components: i.operational_equipment,
                        key: this.genKey(),
                    })),
                    status: data.status,
                    refuse_cause: data.refuse_cause,
                    audit_time: data.audit_time,
                    auditor: data.auditor,
                };
            }
        }
    }
    render(h) {
        return (
            <Modal title={this.operate + '运维申报'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="申报类型" prop="declare_type" required type="number" style="display: inline-block;width:45%">
                        <EntitySelect type={EnumEntity.DeclareType.getId()} v-model={this.formData.declare_type} />
                    </form-item>
                    <form-item
                        labelWidth={140}
                        label="预计运维时长（h）"
                        prop="operational_time"
                        required
                        type="number"
                        style="display: inline-block;width:45%"
                    >
                        <InputNumber
                            class="wqms-input-number"
                            min={0}
                            precision={1}
                            v-model={this.formData.operational_time}
                            placeholder="请输入"
                        />
                    </form-item>
                    <form-item label="原因" prop="cause" style="display: inline-block;width:90%" required>
                        <Input placeholder="请输入" v-model={this.formData.cause} type="textarea" />
                    </form-item>
                    <form-item label="发起时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                    </form-item>
                    <form-item label="运维设备" class={createNamespace('mt15')} />
                    {this.formData.operationalSite.map((i, index) => {
                        return (
                            <div key={i.key}>
                                <form-item
                                    label="运维站点"
                                    prop={`operationalSite.${index}.deviceId`}
                                    required
                                    type="number"
                                    style="width:45%"
                                >
                                    <EntitySelect type={EnumEntity.Station.getId()} v-model={i.deviceId} />
                                </form-item>
                                <form-item
                                    label="运维设备"
                                    prop={`operationalSite.${index}.components`}
                                    required
                                    type="array"
                                    style="display: inline-block;width:70%"
                                >
                                    <EntitySelect
                                        useNameAsId
                                        type={EnumEntity.ComponentById.getId()}
                                        v-model={i.components}
                                        searchParams={{ id: i.deviceId }}
                                        multiple
                                    />
                                </form-item>
                                <form-item label="" labelWidth={10} required type="number" style="display: inline-block;width:20%">
                                    <img
                                        on-click={this.add.bind(this, index)}
                                        src={require('../../../assets/images/add.png')}
                                        height="32px"
                                        class={createNamespace('mr10')}
                                    />
                                    <img
                                        on-click={this.sub.bind(this, index)}
                                        v-if={this.formData.operationalSite.length > 1}
                                        src={require('../../../assets/images/sub.png')}
                                        height="32px"
                                    />
                                </form-item>
                            </div>
                        );
                    })}
                    <div v-if={this.operate === EnumOperates.Update.getName()} class={createNamespace('detail-form')}>
                        <form-item
                            labelWidth={90}
                            label="审核情况"
                            class={createNamespace('mt15')}
                            v-if={this.operate === EnumOperates.Update.getName()}
                        />

                        <form-item label="审核状态：" style="width:90%">
                            {EnumMaintenanceAuditStatus.findId(this.formData.status).getName()}
                        </form-item>
                        <form-item
                            label="审核人："
                            style="width:90%"
                            v-if={this.formData.status !== EnumMaintenanceAuditStatus.UnAudit.getId()}
                        >
                            {this.formData.auditor}
                        </form-item>
                        <form-item
                            label="审核时间："
                            style="width:90%"
                            v-if={this.formData.status !== EnumMaintenanceAuditStatus.UnAudit.getId()}
                        >
                            {this.formData.audit_time}
                        </form-item>
                        <form-item
                            label="不通过原因："
                            style="width:90%"
                            v-if={this.formData.status === EnumMaintenanceAuditStatus.Reject.getId()}
                        >
                            {this.formData.refuse_cause}
                        </form-item>
                    </div>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertOperateMaintenanceModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<OperateMaintenanceVOI.PropsI>(OperateMaintenanceModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
